export const isNewUser = localStorage.getItem('type') === 'new_user';